import { render, staticRenderFns } from "./match-details-modal.vue?vue&type=template&id=848b7ea6&scoped=true&"
import script from "./match-details-modal.vue?vue&type=script&lang=ts&"
export * from "./match-details-modal.vue?vue&type=script&lang=ts&"
import style0 from "./match-details-modal.vue?vue&type=style&index=0&id=848b7ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848b7ea6",
  null
  
)

export default component.exports